import React, { useState } from 'react';
import { Modal, Input, Button, notification } from 'antd'; // + notification

function CopyPastePopup({ selectedOptions, setSelectedOptions, col, options, disabled }) {
    const [visible, setVisible] = useState(false);
    const [text, setText] = useState('');

    const showModal = () => {
        setText(selectedOptions.join('\n'));
        setVisible(true);
    };

    const handleOk = () => {
        console.log('Options Avaialble ',options)
        // ONLY match by new lines
        const newTextInput = text
            .split(/\r?\n/)
            .map(s => s.trim())
            .filter(Boolean);

        // fix: Set doesn't have .filter; convert to array
        const uniqueValues = Array.from(new Set(newTextInput));
        
        const optionStrings = options.map(o => (typeof o === 'object' ? o.value : o));
        const validInput = uniqueValues.filter(value =>
            optionStrings.includes(value)
        );

        if (validInput.length === 0) {
            // Show top-right notification, do NOT close modal
            notification.open({
                message: 'Values Not Found',
                description: 'None of the pasted lines matched the available options.',
                placement: 'topRight',
                style: {
                background: '#fff4e5',
                border: '1px solid #ffe1b3',
                borderRadius: 8,
                fontWeight: 600,
                fontSize: 14,
                color: '#3b2f2f'
            },
                duration: 5
            });
            return;
        }

        // If matches found: set and close modal
        setSelectedOptions(validInput);
        setVisible(false);
    };

    const handleText = (e) => {
        setText(e.target.value);
    };

    return (
        <div>
            <Button onClick={showModal} disabled={disabled}>Copy & Paste</Button>
            <Modal
                title={`Copy & Paste ${col}`}
                open={visible}
                onOk={handleOk}
                onCancel={() => setVisible(false)}
            >
                <Input.TextArea value={text} rows={8} onChange={handleText} />
            </Modal>
        </div>
    );
}

export default CopyPastePopup;